import { subscriptionRepository } from '../repositories/subscription-repository';

async function getSubscriptionPlans(languageCode) {
    return subscriptionRepository.getPlans(languageCode);
}

export {
    getSubscriptionPlans
};
